import { useState, useEffect } from 'react';
import { MOBILE_BREAKPOINT } from '../config/constants.js';

/**
 * モバイル表示かどうかをメディアクエリで判定（ブレークポイント: MOBILE_BREAKPOINT = 900px）
 * @returns {boolean}
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const handler = (e) => setIsMobile(e.matches);
    handler(mql);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
